interface SolutionSectionProps {
  onCtaClick: () => void;
}

const points = [
  {
    title: 'Dein Trainer. Jede einzelne Minute.',
    text: 'Bei uns wirst du nicht mit einem Trainingsplan allein gelassen. Ein zertifizierter Trainer ist von der ersten bis zur letzten Minute bei dir – korrigiert, motiviert, kennt deinen Namen, kennt deinen Körper.',
  },
  {
    title: '20 Minuten. Mehr Wirkung als 90 Minuten klassisch.',
    text: 'EMS aktiviert bis zu 90 % aller Muskelfasern gleichzeitig – auch die tiefliegenden, die du mit herkömmlichen Übungen kaum erreichst. Das ist keine Behauptung, das ist Physiologie.',
  },
  {
    title: 'Gelenkschonend. Ideal bei Rücken- oder Alltagsbeschwerden.',
    text: 'Keine schweren Gewichte, keine Gelenküberbelastung. Ideal nach langer Pause, bei Rückenproblemen, Verspannungen – oder wenn du einfach sanft und nachhaltig einsteigen willst.',
  },
];

const compare = [
  { label: 'Zeit pro Einheit', ems: '20 Minuten', classic: '60–90 Minuten' },
  { label: 'Persönliche Betreuung', ems: 'Immer dabei', classic: 'Kaum vorhanden' },
  { label: 'aktivierte Muskeln', ems: 'Bis zu 90 %', classic: 'Ca. 30–40 %' },
  { label: 'Gelenkbelastung', ems: 'Sehr gering', classic: 'Mittel bis hoch' },
];

export default function SolutionSection({ onCtaClick }: SolutionSectionProps) {
  return (
    <section id="loesung" className="py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center mb-20">
          <div className="relative order-2 lg:order-1">
            <div className="relative overflow-hidden rounded-3xl w-full h-[420px] md:h-[560px]">
              <img
                src="https://storage.readdy-site.link/project_files/39a14c12-a9bc-487a-8116-959d368b9fcb/b0ca7baf-0b85-4721-a24d-8d37c6b7a5e8_IMG-20260225-WA0078.jpg?v=b756ee1ddd4d0d2b6b302e83ed5d2d4d"
                alt="Persönliches EMS-Training bei Körperformen Pinneberg"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5">
                <div
                  className="rounded-2xl p-4 flex items-center gap-4 backdrop-blur-sm"
                  style={{ backgroundColor: 'rgba(255,255,255,0.96)' }}
                >
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: '#1A5C3D' }}
                  >
                    <span className="text-white font-bold text-lg" style={{ fontFamily: 'Playfair Display, serif' }}>20</span>
                  </div>
                  <div>
                    <div className="text-gray-900 font-semibold text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                      20 Minuten pro Woche
                    </div>
                    <div className="text-gray-400 text-xs mt-0.5" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}>
                      Wissenschaftlich belegt · Medizinisch geprüft
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span
              className="text-xs font-medium tracking-[0.2em] uppercase"
              style={{ fontFamily: 'Inter, sans-serif', color: '#1A5C3D' }}
            >
              Die Lösung
            </span>
            <h2
              className="text-3xl md:text-[46px] font-bold text-gray-900 mt-4 leading-[1.1] tracking-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              EMS-Training.<br />
              Gebaut für deinen Alltag –<br />
              <em className="not-italic" style={{ color: '#1A5C3D' }}>nicht dagegen.</em>
            </h2>
            <p
              className="text-gray-500 text-base md:text-lg mt-6 leading-relaxed"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
            >
              Körperformen Pinneberg ist kein Ort, an dem du allein gelassen wirst.
              Ein persönlicher Trainer. Ein fester Termin. Ein Training, das zu dir passt –
              nicht zu irgendjemand anders.
            </p>

            <div className="mt-9 space-y-7">
              {points.map((item, i) => (
                <div key={i} className="flex gap-4 items-start">
                  <div
                    className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 rounded-full"
                    style={{ backgroundColor: 'rgba(26,92,61,0.1)' }}
                  >
                    <i className="ri-check-line text-xs" style={{ color: '#1A5C3D' }}></i>
                  </div>
                  <div>
                    <div className="text-gray-900 font-semibold text-sm leading-snug" style={{ fontFamily: 'Inter, sans-serif' }}>
                      {item.title}
                    </div>
                    <div className="text-gray-500 text-sm mt-1.5 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}>
                      {item.text}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <button
                onClick={onCtaClick}
                className="text-white font-semibold text-sm px-7 py-3.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ backgroundColor: '#1A5C3D', fontFamily: 'Inter, sans-serif' }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#1E6B47')}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#1A5C3D')}
              >
                Kostenlos ausprobieren →
              </button>
              <span className="text-gray-400 text-xs ml-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                unverbindlich · in Pinneberg
              </span>
            </div>
          </div>
        </div>

        <div className="rounded-3xl overflow-hidden border" style={{ borderColor: '#E4EDE8' }}>
          <div className="px-6 md:px-10 py-7 border-b" style={{ backgroundColor: '#F7FAF8', borderColor: '#E4EDE8' }}>
            <h3
              className="text-gray-900 font-semibold text-lg"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              EMS vs. klassisches Training – der direkte Vergleich
            </h3>
            <p
              className="text-gray-400 text-sm mt-1"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
            >
              Warum immer mehr Pinneberg-Berufstätige wechseln.
            </p>
          </div>
          {/* Column headers */}
          <div className="grid grid-cols-3 px-3 md:px-10 py-3 border-b text-xs" style={{ borderColor: '#E4EDE8', backgroundColor: '#F0F5F2' }}>
            <div style={{ color: 'transparent' }}>–</div>
            <div className="font-semibold" style={{ fontFamily: 'Inter, sans-serif', color: '#1A5C3D' }}>Körperformen EMS</div>
            <div style={{ fontFamily: 'Inter, sans-serif', color: '#9CA3AF' }}>Klassisch</div>
          </div>
          <div className="grid grid-cols-1 divide-y" style={{ divideColor: '#E4EDE8' }}>
            {compare.map((row, i) => (
              <div
                key={i}
                className="grid grid-cols-3 text-xs md:text-sm"
              >
                <div
                  className="px-3 md:px-10 py-3 md:py-4 flex items-center border-r"
                  style={{ backgroundColor: '#FAFCFB', borderColor: '#E4EDE8', fontFamily: 'Inter, sans-serif', color: '#6B7280', fontWeight: 400 }}
                >
                  {row.label}
                </div>
                <div
                  className="px-3 md:px-8 py-3 md:py-4 flex items-center gap-1 md:gap-2 border-r"
                  style={{ backgroundColor: 'rgba(26,92,61,0.04)', borderColor: '#E4EDE8' }}
                >
                  <div className="w-3.5 h-3.5 md:w-4 md:h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-xs" style={{ color: '#1A5C3D' }}></i>
                  </div>
                  <span className="font-semibold leading-tight" style={{ fontFamily: 'Inter, sans-serif', color: '#1A5C3D' }}>
                    {row.ems}
                  </span>
                </div>
                <div
                  className="px-3 md:px-8 py-3 md:py-4 flex items-center"
                  style={{ backgroundColor: '#FAFCFB' }}
                >
                  <span className="leading-tight" style={{ fontFamily: 'Inter, sans-serif', color: '#9CA3AF' }}>
                    {row.classic}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
